//! Common or dashboard
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_IS_SIDEBAR_OPEN = "SET_IS_SIDEBAR_OPEN";

//! Auth
export const ADMIN_LOGIN = "ADMIN_LOGIN"

//! Dashboard
export const GET_DASHBOARD = "GET_DASHBOARD";
export const SET_DASHBOARD = "SET_DASHBOARD";


//! Astrologer
export const GET_ASTROLOGER = 'GET_ASTROLOGER';
export const SET_ASTROLOGER = 'SET_ASTROLOGER';
export const GET_ENQUIRY_ASTROLOGER = 'GET_ENQUIRY_ASTROLOGER';
export const SET_ENQUIRY_ASTROLOGER = 'SET_ENQUIRY_ASTROLOGER';
export const GET_ASTROLOGER_BY_ID = 'GET_ASTROLOGER_BY_ID';
export const SET_ASTROLOGER_BY_ID = 'SET_ASTROLOGER_BY_ID';
export const CREATE_ASTROLOGER = 'CREATE_ASTROLOGER';
export const UPDATE_ASTROLOGER_BY_ID = 'UPDATE_ASTROLOGER_by_ID';
export const DELETE_ASTROLOGER_BY_ID = 'DELETE_ASTROLOGER_by_ID';
export const GET_CHAT_HISTORY_BY_ASTROLOGER_ID = 'GET_CHAT_HISTORY_BY_ASTROLOGER_ID';
export const SET_CHAT_HISTORY_BY_ASTROLOGER_ID = 'SET_CHAT_HISTORY_BY_ASTROLOGER_ID';
export const GET_CALL_HISTORY_BY_ASTROLOGER_ID = 'GET_CALL_HISTORY_BY_ASTROLOGER_ID';
export const SET_CALL_HISTORY_BY_ASTROLOGER_ID = 'SET_CALL_HISTORY_BY_ASTROLOGER_ID';
export const GET_VIDEO_CALL_HISTORY_BY_ASTROLOGER_ID = 'GET_VIDEO_CALL_HISTORY_BY_ASTROLOGER_ID';
export const SET_VIDEO_CALL_HISTORY_BY_ASTROLOGER_ID = 'SET_VIDEO_CALL_HISTORY_BY_ASTROLOGER_ID';
export const GET_LIVE_HISTORY_BY_ASTROLOGER_ID = 'GET_LIVE_HISTORY_BY_ASTROLOGER_ID';
export const SET_LIVE_HISTORY_BY_ASTROLOGER_ID = 'SET_LIVE_HISTORY_BY_ASTROLOGER_ID';
export const GET_GIFT_HISTORY_BY_ASTROLOGER_ID = 'GET_GIFT_HISTORY_BY_ASTROLOGER_ID';
export const SET_GIFT_HISTORY_BY_ASTROLOGER_ID = 'SET_GIFT_HISTORY_BY_ASTROLOGER_ID';
export const GET_REVIEW_BY_ASTROLOGER_ID = 'GET_REVIEW_BY_ASTROLOGER_ID';
export const SET_REVIEW_BY_ASTROLOGER_ID = 'SET_REVIEW_BY_ASTROLOGER_ID';
export const GET_TRANSACTION_HISTORY_BY_ASTROLOGER_ID = 'GET_TRANSACTION_HISTORY_BY_ASTROLOGER_ID';
export const SET_TRANSACTION_HISTORY_BY_ASTROLOGER_ID = 'SET_TRANSACTION_HISTORY_BY_ASTROLOGER_ID';
export const GET_PUJA_HISTORY_BY_ASTROLOGER_ID = 'GET_PUJA_HISTORY_BY_ASTROLOGER_ID';
export const SET_PUJA_HISTORY_BY_ASTROLOGER_ID = 'SET_PUJA_HISTORY_BY_ASTROLOGER_ID';
export const UPDATE_WALLET_BY_ASTROLOGER_ID = 'UPDATE_WALLET_BY_ASTROLOGER_ID';
export const VERIFY_ASTROLOGER_PROFILE = 'VERIFY_ASTROLOGER_PROFILE';
export const CHANGE_ASTROLOGER_CHAT_STATUS = 'CHANGE_ASTROLOGER_CHAT_STATUS';
export const CHANGE_ASTROLOGER_CALL_STATUS = 'CHANGE_ASTROLOGER_CALL_STATUS';
export const CHANGE_ASTROLOGER_VIDEO_CALL_STATUS = 'CHANGE_ASTROLOGER_VIDEO_CALL_STATUS';

//! User
export const GET_USER = "GET_USER";
export const SET_USER = "SET_USER";
export const CREATE_USER = "CREATE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const CHANGE_USER_STATUS = "CHANGE_USER_STATUS";

//! Sub Admin
export const GET_SUB_ADMIN = "GET_SUB_ADMIN";
export const SET_SUB_ADMIN = "SET_SUB_ADMIN";
export const CREATE_SUB_ADMIN = "CREATE_SUB_ADMIN";
export const UPDATE_SUB_ADMIN = "UPDATE_SUB_ADMIN";
export const DELETE_SUB_ADMIN = "DELETE_SUB_ADMIN";
export const CHANGE_SUB_ADMIN_STATUS = "CHANGE_SUB_ADMIN_STATUS";

//! Astro-Mall
export const GET_ASTRO_MALL_CATEGORY = 'GET_ASTRO_MALL_CATEGORY';
export const SET_ASTRO_MALL_CATEGORY = 'SET_ASTRO_MALL_CATEGORY';
export const CREATE_ASTRO_MALL_CATEGORY = 'CREATE_ASTRO_MALL_CATEGORY';
export const UPDATE_ASTRO_MALL_CATEGORY = 'UPDATE_ASTRO_MALL_CATEGORY';
export const DELETE_ASTRO_MALL_CATEGORY = 'DELETE_ASTRO_MALL_CATEGORY';

//* Product
export const GET_ASTRO_MALL_PRODUCT = 'GET_ASTRO_MALL_PRODUCT';
export const SET_ASTRO_MALL_PRODUCT = 'SET_ASTRO_MALL_PRODUCT';
export const CREATE_ASTRO_MALL_PRODUCT = 'CREATE_ASTRO_MALL_PRODUCT';
export const UPDATE_ASTRO_MALL_PRODUCT = 'UPDATE_ASTRO_MALL_PRODUCT';
export const DELETE_ASTRO_MALL_PRODUCT = 'DELETE_ASTRO_MALL_PRODUCT';

//* Order History
export const GET_ORDER_HISTORY = 'GET_ORDER_HISTORY';
export const SET_ORDER_HISTORY = 'SET_ORDER_HISTORY';
export const CHANGE_ORDER_STATUS = 'CHANGE_ORDER_STATUS';

//! Astro-Puja
export const GET_PUJA = 'GET_PUJA';
export const SET_PUJA = 'SET_PUJA';
export const CREATE_PUJA = 'CREATE_PUJA';
export const UPDATE_PUJA = 'UPDATE_PUJA';
export const DELETE_PUJA = 'DELETE_PUJA';
export const GET_PUJA_REQUEST = 'GET_PUJA_REQUEST';
export const SET_PUJA_REQUEST = 'SET_PUJA_REQUEST';
export const ASSIGN_PUJA = 'ASSIGN_PUJA';
export const CHANGE_PUJA_STATUS = 'CHANGE_PUJA_STATUS';
export const GET_PUJA_BOOKED = 'GET_PUJA_BOOKED';
export const SET_PUJA_BOOKED = 'SET_PUJA_BOOKED';
export const GET_PUJA_HISTORY = 'GET_PUJA_HISTORY';
export const SET_PUJA_HISTORY = 'SET_PUJA_HISTORY';

//! History
export const GET_CHAT_HISTORY = "GET_CHAT_HISTORY";
export const SET_CHAT_HISTORY = "SET_CHAT_HISTORY";
export const GET_CALL_HISTORY = "GET_CALL_HISTORY";
export const SET_CALL_HISTORY = "SET_CALL_HISTORY";
export const GET_VIDEO_CALL_HISTORY = "GET_VIDEO_CALL_HISTORY";
export const SET_VIDEO_CALL_HISTORY = "SET_VIDEO_CALL_HISTORY";
export const GET_LIVE_HISTORY = "GET_LIVE_HISTORY";
export const SET_LIVE_HISTORY = "SET_LIVE_HISTORY";
export const GET_GIFT_HISTORY = "GET_GIFT_HISTORY";
export const SET_GIFT_HISTORY = "SET_GIFT_HISTORY";
export const GET_SERVICE_HISTORY = 'GET_SERVICE_HISTORY';
export const SET_SERVICE_HISTORY = 'SET_SERVICE_HISTORY'

//! Skill
export const GET_SKILL = 'GET_SKILL';
export const SET_SKILL = 'SET_SKILL';
export const CREATE_SKILL = 'CREATE_SKILL';
export const UPDATE_SKILL = 'UPDATE_SKILL';
export const DELETE_SKILL = 'DELETE_SKILL';

//! Remedies
export const GET_REMEDIES = 'GET_REMEDIES';
export const SET_REMEDIES = 'SET_REMEDIES';
export const CREATE_REMEDIES = 'CREATE_REMEDIES';
export const UPDATE_REMEDIES = 'UPDATE_REMEDIES';
export const DELETE_REMEDIES = 'DELETE_REMEDIES';

//! Expertise
export const GET_EXPERTISE = "GET_EXPERTISE";
export const SET_EXPERTISE = "SET_EXPERTISE";
export const CREATE_EXPERTISE = "CREATE_EXPERTISE";
export const UPDATE_EXPERTISE = "UPDATE_EXPERTISE";
export const DELETE_EXPERTISE = "DELETE_EXPERTISE";
export const GET_MAIN_EXPERTISE = "GET_MAIN_EXPERTISE";
export const SET_MAIN_EXPERTISE = "SET_MAIN_EXPERTISE";
export const CREATE_MAIN_EXPERTISE = "CREATE_MAIN_EXPERTISE";
export const UPDATE_MAIN_EXPERTISE = "UPDATE_MAIN_EXPERTISE";
export const DELETE_MAIN_EXPERTISE = "DELETE_MAIN_EXPERTISE";

//! Language
export const GET_LANGUAGE = "GET_LANGUAGE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const CREATE_LANGUAGE = "CREATE_LANGUAGE";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const DELETE_LANGUAGE = "DELETE_LANGUAGE";

//! Banner
export const GET_BANNER = "GET_BANNER";
export const SET_BANNER = "SET_BANNER";
export const CREATE_BANNER = "CREATE_BANNER";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";
export const CHANGE_BANNER_STATUS = "CHANGE_BANNER_STATUS";

//! Category
export const GET_CATEGORY = "GET_CATEGORY";
export const SET_CATEGORY = "SET_CATEGORY";
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const CHANGE_CATEGORY_STATUS = "CHANGE_CATEGORY_STATUS";

//! Sub-Category
export const GET_SUB_CATEGORY = "GET_SUB_CATEGORY";
export const SET_SUB_CATEGORY = "SET_SUB_CATEGORY";
export const CREATE_SUB_CATEGORY = "CREATE_SUB_CATEGORY";
export const UPDATE_SUB_CATEGORY = "UPDATE_SUB_CATEGORY";
export const DELETE_SUB_CATEGORY = "DELETE_SUB_CATEGORY";
export const CHANGE_SUB_CATEGORY_STATUS = "CHANGE_SUB_CATEGORY_STATUS";
export const GET_SUB_CATEGORY_BY_CATEGORY_ID = "GET_SUB_CATEGORY_BY_CATEGORY_ID";
export const SET_SUB_CATEGORY_BY_CATEGORY_ID = "SET_SUB_CATEGORY_BY_CATEGORY_ID";

//! Yatra
export const GET_YATRA = "GET_YATRA";
export const SET_YATRA = "SET_YATRA";
export const CREATE_YATRA = "CREATE_YATRA";
export const UPDATE_YATRA = "UPDATE_YATRA";
export const DELETE_YATRA = "DELETE_YATRA";
export const CHANGE_YATRA_STATUS = "CHANGE_YATRA_STATUS";

export const GET_YATRA_HISTORY = 'GET_YATRA_HISTORY'
export const SET_YATRA_HISTORY = 'SET_YATRA_HISTORY'

//! Sanchar
//? Podcast
export const GET_PODCAST = "GET_PODCAST";
export const SET_PODCAST = "SET_PODCAST";
export const CREATE_PODCAST = "CREATE_PODCAST";
export const UPDATE_PODCAST = "UPDATE_PODCAST";
export const DELETE_PODCAST = "DELETE_PODCAST";
export const CHANGE_PODCAST_STATUS = "CHANGE_PODCAST_STATUS";

//? Videoclip
export const GET_VIDEOCLIP = "GET_VIDEOCLIP";
export const SET_VIDEOCLIP = "SET_VIDEOCLIP";
export const CREATE_VIDEOCLIP = "CREATE_VIDEOCLIP";
export const UPDATE_VIDEOCLIP = "UPDATE_VIDEOCLIP";
export const DELETE_VIDEOCLIP = "DELETE_VIDEOCLIP";
export const CHANGE_VIDEOCLIP_STATUS = "CHANGE_VIDEOCLIP_STATUS";

//? News
export const GET_NEWS = "GET_NEWS";
export const SET_NEWS = "SET_NEWS";
export const CREATE_NEWS = "CREATE_NEWS";
export const UPDATE_NEWS = "UPDATE_NEWS";
export const DELETE_NEWS = "DELETE_NEWS";
export const CHANGE_NEWS_STATUS = "CHANGE_NEWS_STATUS";

//? Live
export const GET_LIVE = "GET_LIVE";
export const SET_LIVE = "SET_LIVE";
export const CREATE_LIVE = "CREATE_LIVE";
export const UPDATE_LIVE = "UPDATE_LIVE";
export const DELETE_LIVE = "DELETE_LIVE";
export const CHANGE_LIVE_STATUS = "CHANGE_LIVE_STATUS";

//? Consltant
export const GET_CONSULTANT_DATA = 'GET_CONSULTANT_DATA'
export const SET_CONSULTANT_DATA = 'SET_CONSULTANT_DATA'

//! Religious
//? Daily Darshan
export const GET_DAILY_DARSHAN = "GET_DAILY_DARSHAN";
export const SET_DAILY_DARSHAN = "SET_DAILY_DARSHAN";
export const CREATE_DAILY_DARSHAN = "CREATE_DAILY_DARSHAN";
export const UPDATE_DAILY_DARSHAN = "UPDATE_DAILY_DARSHAN";
export const DELETE_DAILY_DARSHAN = "DELETE_DAILY_DARSHAN";
export const CHANGE_DAILY_DARSHAN_STATUS = "CHANGE_DAILY_DARSHAN_STATUS";

//! Ecommerce
export const GET_ECOMMERCE_CATEGORY = "GET_ECOMMERCE_CATEGORY";
export const SET_ECOMMERCE_CATEGORY = "SET_ECOMMERCE_CATEGORY";
export const CREATE_ECOMMERCE_CATEGORY = "CREATE_ECOMMERCE_CATEGORY";
export const UPDATE_ECOMMERCE_CATEGORY = "UPDATE_ECOMMERCE_CATEGORY";
export const DELETE_ECOMMERCE_CATEGORY = "DELETE_ECOMMERCE_CATEGORY";
export const CHANGE_ECOMMERCE_CATEGORY_STATUS = "CHANGE_ECOMMERCE_CATEGORY_STATUS";

export const GET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID = "GET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID";
export const SET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID = "SET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID";

export const GET_ECOMMERCE_SUB_CATEGORY = "GET_ECOMMERCE_SUB_CATEGORY";
export const SET_ECOMMERCE_SUB_CATEGORY = "SET_ECOMMERCE_SUB_CATEGORY";
export const CREATE_ECOMMERCE_SUB_CATEGORY = "CREATE_ECOMMERCE_SUB_CATEGORY";
export const UPDATE_ECOMMERCE_SUB_CATEGORY = "UPDATE_ECOMMERCE_SUB_CATEGORY";
export const DELETE_ECOMMERCE_SUB_CATEGORY = "DELETE_ECOMMERCE_SUB_CATEGORY";
export const CHANGE_ECOMMERCE_SUB_CATEGORY_STATUS = "CHANGE_ECOMMERCE_SUB_CATEGORY_STATUS";

export const GET_ECOMMERCE_ATTRIBUTE = "GET_ECOMMERCE_ATTRIBUTE";
export const SET_ECOMMERCE_ATTRIBUTE = "SET_ECOMMERCE_ATTRIBUTE";
export const CREATE_ECOMMERCE_ATTRIBUTE = "CREATE_ECOMMERCE_ATTRIBUTE";
export const UPDATE_ECOMMERCE_ATTRIBUTE = "UPDATE_ECOMMERCE_ATTRIBUTE";
export const DELETE_ECOMMERCE_ATTRIBUTE = "DELETE_ECOMMERCE_ATTRIBUTE";
export const CHANGE_ECOMMERCE_ATTRIBUTE_STATUS = "CHANGE_ECOMMERCE_ATTRIBUTE_STATUS";

export const GET_ECOMMERCE_PRODUCT = "GET_ECOMMERCE_PRODUCT";
export const SET_ECOMMERCE_PRODUCT = "SET_ECOMMERCE_PRODUCT";
export const CREATE_ECOMMERCE_PRODUCT = "CREATE_ECOMMERCE_PRODUCT";
export const UPDATE_ECOMMERCE_PRODUCT = "UPDATE_ECOMMERCE_PRODUCT";
export const DELETE_ECOMMERCE_PRODUCT = "DELETE_ECOMMERCE_PRODUCT";
export const CHANGE_ECOMMERCE_PRODUCT_STATUS = "CHANGE_ECOMMERCE_PRODUCT_STATUS";

//! Static Page
export const GET_ABOUT_US = 'GET_ABOUT_US';
export const SET_ABOUT_US = 'SET_ABOUT_US';
export const CREATE_ABOUT_US = 'CREATE_ABOUT_US';
export const GET_TERMS_AND_CONDITION = 'GET_TERMS_AND_CONDITION';
export const SET_TERMS_AND_CONDITION = 'SET_TERMS_AND_CONDITION';
export const CREATE_TERMS_AND_CONDITION = 'CREATE_TERMS_AND_CONDITION';
export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const CREATE_PRIVACY_POLICY = 'CREATE_PRIVACY_POLICY';
export const GET_REFUND_POLICY = 'GET_REFUND_POLICY';
export const SET_REFUND_POLICY = 'SET_REFUND_POLICY';
export const CREATE_REFUND_POLICY = 'CREATE_REFUND_POLICY';
// export const CREATE_COOKIES_POLICY = 'CREATE_COOKIES_POLICY';

//! Payment
export const GET_PAYMENT_HISTORY = "GET_PAYMENT_HISTORY";
export const SET_PAYMENT_HISTORY = "SET_PAYMENT_HISTORY";

//! Testimonials
export const GET_TESTIMONIALS = "GET_TESTIMONIALS";
export const SET_TESTIMONIALS = "SET_TESTIMONIALS";
export const CREATE_TESTIMONIALS = "CREATE_TESTIMONIALS";
export const UPDATE_TESTIMONIALS = "UPDATE_TESTIMONIALS";
export const DELETE_TESTIMONIALS = "DELETE_TESTIMONIALS";
export const CHANGE_TESTIMONIALS_STATUS = "CHANGE_TESTIMONIALS_STATUS";

//! Transaction
export const GET_TRANSACTION_HISTORY = "GET_TRANSACTION_HISTORY";
export const SET_TRANSACTION_HISTORY = "SET_TRANSACTION_HISTORY";

//! Operator Image
export const GET_OPERATOR = "GET_OPERATOR";
export const SET_OPERATOR = "SET_OPERATOR";
export const GET_OPERATOR_IMAGES = "GET_OPERATOR_IMAGES";
export const SET_OPERATOR_IMAGES = "SET_OPERATOR_IMAGES";
export const CREATE_OPERATOR_IMAGES = "CREATE_OPERATOR_IMAGES";
export const UPDATE_OPERATOR_IMAGES = "UPDATE_OPERATOR_IMAGES";
export const DELETE_OPERATOR_IMAGES = "DELETE_OPERATOR_IMAGES";

//! Flight Image
export const GET_FLIGHT_IMAGES = "GET_FLIGHT_IMAGES";
export const SET_FLIGHT_IMAGES = "SET_FLIGHT_IMAGES";
export const CREATE_FLIGHT_IMAGES = "CREATE_FLIGHT_IMAGES";
export const UPDATE_FLIGHT_IMAGES = "UPDATE_FLIGHT_IMAGES";
//! Roles & Logs
export const GET_ROLES = "GET_ROLES";
export const SET_ROLES = "SET_ROLES";
export const CREATE_ROLE = "CREATE_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const GET_ACTIVITY_LOGS = "GET_ACTIVITY_LOGS";
export const SET_ACTIVITY_LOGS = "SET_ACTIVITY_LOGS";
export const GET_MODULES = "GET_MODULES";
export const SET_MODULES = "SET_MODULES";

//! Issue Control
export const GET_ISSUES = "GET_ISSUES";
export const SET_ISSUES = "SET_ISSUES";
export const GET_ACTIVE_ISSUES = "GET_ACTIVE_ISSUES";
export const SET_ACTIVE_ISSUES = "SET_ACTIVE_ISSUES";
export const GET_ISSUE_BY_ID = "GET_ISSUE_BY_ID";
export const SET_ISSUE_BY_ID = "SET_ISSUE_BY_ID";
export const GET_ISSUE_STATS = "GET_ISSUE_STATS";
export const SET_ISSUE_STATS = "SET_ISSUE_STATS";
export const CREATE_ISSUE = "CREATE_ISSUE";
export const CHANGE_ISSUE_STATUS = "CHANGE_ISSUE_STATUS";
export const ADD_ISSUE_COMMENT = "ADD_ISSUE_COMMENT";
